import React from 'react';
import classnames from 'classnames';
import styles from './code-phone.css';
import bindAll from 'lodash.bindall';


import CodeSelector from '../code-selector/code-selector.jsx';
import blocks from 'scratch-blocks';

import close from '../code-panel/icon--close.png';
import full from '../stage-header/icon--fullscreen.png';

class CodePhone extends React.Component {
    constructor() {
        super()
        this.state = {
            fullshow: false
        }
        bindAll(this, [
            'handleClose',
            'onChangeCode',
            'fullscreen',
            'handleChangeWidth',
        ])
    }

    handleClose() {
        document.getElementById("phoneCode").style.display = 'none';
    }
    onChangeCode() {
        this.props.vm.toCode();
    }
    fullscreen() {
        if (this.state.fullshow) {
            this.menu.style.width = "24rem";
        } else {
            this.menu.style.width = "100%";
        }
        this.setState({
            fullshow: !this.state.fullshow
        })

    }

    handleChangeWidth(e) {
        e.preventDefault()
        var code = document.getElementById('phoneCode');
        var width = code.clientWidth;
        var current = e.touches[0].clientX;
        document.ontouchmove = function (e) {
            var num = current - e.touches[0].clientX
            var changewidth = width + num
            if (changewidth <= 200) {
                code.style.width = 200 + 'px';
            } else {
                code.style.width = changewidth + 'px';
            }
        };

        document.ontouchend = function () {
            document.ontouchmove = null;
            document.ontouchend = null;
        };
    }

    render() {
        const robotArray = [
            ['role', 'bg', 'E6', 'M6', 'E7'],
            ['role', 'bg', 'E6', 'M6', 'C1', 'A2', 'E3', 'E7']
        ];
        let type = 'E6'
        if (this.props.vm.editingTarget) {
            type = this.props.vm.editingTarget.robotType
        }
        return (
            <div id="phoneCode" ref={menu => this.menu = menu} className={classnames(styles.box)}>
                <div className={styles.close} onTouchStart={this.handleClose}>
                    <img src={close} width="100%" alt="" draggable="false" />
                </div>
                <div className={styles.line} onTouchStart={this.handleChangeWidth} />
                <div className={styles.selectType}>
                    <div>
                        {blocks.getalls().is_mobi ? <CodeSelector
                            onChangeCode={() => { this.onChangeCode() }}
                            robotType={type}
                            robotArray={robotArray}
                        /> : null}
                    </div>
                    <div className={styles.fullScreen}>
                        <img src={full} alt="" onTouchStart={this.fullscreen} />
                    </div>
                </div>
                <div className={styles.textContent} />
            </div>
        )
    }
}

export default CodePhone